/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfLab } from '../../models/data-page-of-lab';

export interface LabsDetail$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  page?: number;
  TestName?: string | null;
  OBRID?: string | null;
}

export function labsDetail(http: HttpClient, rootUrl: string, params?: LabsDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfLab>> {
  const rb = new RequestBuilder(rootUrl, labsDetail.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('page', params.page, {});
    rb.query('TestName', params.TestName, {});
    rb.query('OBRID', params.OBRID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfLab>;
    })
  );
}

labsDetail.PATH = '/lab/detail';
